import * as React from 'react';
import { SVGProps } from 'react';

const IconPauseSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 3H2v7h3V3zm4 0H6v7h3V3z" />
  </svg>
);
export default IconPauseSizeXs;
